import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';

import { RootState } from 'app/app.config';

import { Loader } from '../models';
import * as fromLoading from './loading.reducer';

export const loadingFeatureKey = 'loading';

export interface LoadingState {
    [loadingFeatureKey]: fromLoading.State;
}

export interface State extends RootState {
    [loadingFeatureKey]: LoadingState;
}

export function reducers(state: LoadingState | undefined, action: Action) {
    return combineReducers({
        [loadingFeatureKey]: fromLoading.loadingReducer,
    })(state, action);
}

export const getFeature = createFeatureSelector<LoadingState>(loadingFeatureKey);

export const getSlice = createSelector(getFeature, (s) => s[loadingFeatureKey]);

export const getLoaders = createSelector(getSlice, (s) => s.loaders);

export const getMap = createSelector(getLoaders, (d) =>
    d.reduce<Record<string, Loader>>((mp, loader) => {
        mp[loader.id] = loader;
        return mp;
    }, {}),
);

export const getById = (id: string) => createSelector(getMap, (mp) => mp[id]);
